module.exports = __webpack_public_path__ + "static/media/paw-print-dog-treats-smaller.c6dee01f.jpg";